module.exports = __webpack_public_path__ + "static/media/transaction-pending.0a9e32c5.png";